<script lang="ts">
  import type UserLogin from '../domain/user-login';
  import ApiService from '../api-service';
  import { userInfo } from '../stores';
  import { push } from 'svelte-spa-router';
  import axios from 'axios';
  import { Card, Button, TextField } from 'smelte';
  import { form } from 'svelte-forms';
  import ValidationUtils from '../utils/validation-utils';

  let userLogin: UserLogin = {
    username: null,
    password: null
  };

  let loginError = null;

  const loginForm = form(() => ({
    username: { value: userLogin.username, validators: ['required'] },
    password: { value: userLogin.password, validators: ['required'] }
  }));

  $: formErrors = {
    'username': ValidationUtils.createErrors($loginForm, 'username'),
    'password': ValidationUtils.createErrors($loginForm, 'password')
  };

  async function login() {
    let successfulLogin = true;
    try {
      const response = await ApiService.login(userLogin);
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
      axios.defaults.headers.common[
              'Authorization'
              ] = `Bearer ${localStorage.getItem('access_token')}`;
    } catch(error) {
      if (error.response.status === 401) {
        loginError = 'Vale kasutajanimi või parool';
      }
      successfulLogin = false;
    }

    if (successfulLogin) {
      const response2 = await ApiService.getCurrentUser();
      userInfo.set(response2.data);

      push('/');
    }
  }
</script>

<section class="flex justify-center items-center h-screen">
  <Card.Card hover={false} class="w-full md:w-1/3 shadow-lg px-3 py-3">
    <div slot="title" class="p-0 m-0">
      <div class="text-lg pl-4 py-2">Logi sisse</div>
    </div>
    <div slot="text">
      {#if loginError}
        <div class="text-error-500 px-4">{ loginError }</div>
      {/if}
      <TextField name="username" bind:value={userLogin.username} label="Kasutajanimi" error={ValidationUtils.createErrors($loginForm, 'username')}/>
      <TextField name="password" type="password" bind:value={userLogin.password} label="Parool" error={ValidationUtils.createErrors($loginForm, 'password')} on:keyup={e => e.key === 'Enter' && login()}/>
    </div>
    <div slot="actions" class="flex justify-end">
      <Button on:click={login} disabled="{!$loginForm.valid}">Logi sisse</Button>
    </div>
  </Card.Card>
</section>
